(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
  function initCartRecommendations() {
    document.querySelectorAll('[data-cart-recommendations-carousel]').forEach(function (carousel) {
      if (carousel.dataset.cartRecommendationsInitialized) return;
      carousel.dataset.cartRecommendationsInitialized = 'true';

      var track = carousel.querySelector('[data-cart-recommendations-track]');
      var prevButton = carousel.querySelector('[data-cart-recommendations-prev]');
      var nextButton = carousel.querySelector('[data-cart-recommendations-next]');
      if (!track || !prevButton || !nextButton) return;

      var items = Array.prototype.slice.call(track.children);
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        track.insertBefore(items[j], items[i].nextSibling);
        var tmp = items[i];
        items[i] = items[j];
        items[j] = tmp;
      }
      items.forEach(function (item) {
        track.appendChild(item);
      });
      carousel.classList.add('cart-recommendations__carousel--ready');

      function scrollAmount() {
        var item = track.querySelector('.cart-recommendations__item');
        return item ? item.getBoundingClientRect().width + 16 : track.clientWidth;
      }

      function updateButtons() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        prevButton.disabled = track.scrollLeft <= 0;
        nextButton.disabled = track.scrollLeft >= maxScroll;
      }

      prevButton.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons);
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartRecommendations);
  } else {
    initCartRecommendations();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-cards"] && !Shopify.designMode) return;
  try {
    
  function initCategoryCarousels() {
    document.querySelectorAll('[data-category-carousel]').forEach(function (carousel) {
      if (carousel.dataset.categoryCarouselInitialized) return;
      carousel.dataset.categoryCarouselInitialized = 'true';

      var track = carousel.querySelector('[data-category-track]');
      var prevButton = carousel.querySelector('[data-category-prev]');
      var nextButton = carousel.querySelector('[data-category-next]');
      if (!track || !prevButton || !nextButton) return;

      function scrollAmount() {
        var item = track.querySelector('.category-cards__item');
        return item ? item.getBoundingClientRect().width + 16 : track.clientWidth;
      }

      function updateButtons() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        prevButton.disabled = track.scrollLeft <= 0;
        nextButton.disabled = track.scrollLeft >= maxScroll;
      }

      prevButton.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      var autoplay = parseInt(carousel.dataset.autoplay || '0', 10);
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (autoplay > 0 && !reduceMotion) {
        // Conveyor: a hidden copy of the cards follows the originals so the row can
        // keep moving one card at a time and loop seamlessly, even when every card fits.
        var originals = Array.prototype.slice.call(track.children);
        originals.forEach(function (li) {
          var copy = li.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.removeAttribute('data-shopify-editor-block');
          copy.querySelectorAll('a, button').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
          track.appendChild(copy);
        });
        function setWidth() {
          var first = originals[0];
          var copyFirst = track.children[originals.length];
          return copyFirst.offsetLeft - first.offsetLeft;
        }
        function wrap() {
          var w = setWidth();
          if (w > 0 && track.scrollLeft >= w - 2) {
            track.style.scrollBehavior = 'auto';
            track.style.scrollSnapType = 'none';
            track.scrollLeft -= w;
            track.offsetHeight;
            track.style.scrollBehavior = '';
            track.style.scrollSnapType = '';
          }
        }
        var paused = false;
        var resumeTimer = null;
        function pauseFor(ms) {
          paused = true;
          if (resumeTimer) clearTimeout(resumeTimer);
          if (ms) resumeTimer = setTimeout(function () { paused = false; }, ms);
        }
        carousel.addEventListener('mouseenter', function () { pauseFor(0); });
        carousel.addEventListener('mouseleave', function () { paused = false; });
        carousel.addEventListener('focusin', function () { pauseFor(0); });
        carousel.addEventListener('focusout', function () { paused = false; });
        track.addEventListener('touchstart', function () { pauseFor(6000); }, { passive: true });
        [prevButton, nextButton].forEach(function (b) { b.addEventListener('click', function () { pauseFor(6000); }); });
        prevButton.addEventListener('click', function () {
          if (track.scrollLeft <= 2) {
            track.style.scrollBehavior = 'auto';
            track.scrollLeft += setWidth();
            track.style.scrollBehavior = '';
          }
        }, true);
        setInterval(function () {
          if (paused || document.hidden) return;
          wrap();
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
          setTimeout(wrap, 700);
        }, autoplay);
        updateButtons = function () {
          prevButton.disabled = false;
          nextButton.disabled = false;
        };
      }

      track.addEventListener('scroll', updateButtons);
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategoryCarousels);
  } else {
    initCategoryCarousels();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-selectors"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__statsCountInit) return;
    window.__statsCountInit = true;

    function formatNumber(value, hasComma, decimals) {
      var fixed = value.toFixed(decimals);
      if (hasComma) {
        var parts = fixed.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        fixed = parts.join('.');
      }
      return fixed;
    }

    function animateStat(el) {
      var raw = el.textContent.trim();
      var match = raw.match(/[\d,]+(\.\d+)?/);
      if (!match) return;

      var numStr = match[0];
      var target = parseFloat(numStr.replace(/,/g, ''));
      if (isNaN(target)) return;

      var prefix = raw.slice(0, match.index);
      var suffix = raw.slice(match.index + numStr.length);
      var hasComma = numStr.indexOf(',') !== -1;
      var decimals = (numStr.split('.')[1] || '').length;
      var duration = 1000;
      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        el.textContent = prefix + formatNumber(target * progress, hasComma, decimals) + suffix;
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = raw;
        }
      }

      requestAnimationFrame(step);
    }

    function initStatsCount() {
      document.querySelectorAll('[data-stats-number]').forEach(function (el) {
        if (el.dataset.animated) return;
        el.dataset.animated = 'true';
        animateStat(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStatsCount);
    } else {
      initStatsCount();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-product-selector"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var grid = section.querySelector('[data-lp-selector-grid]');
      var prevBtn = section.querySelector('[data-lp-selector-prev]');
      var nextBtn = section.querySelector('[data-lp-selector-next]');
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.lp-selector__card'));
      if (!cards.length) return;

      function isMobile() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      function centerCard(card, smooth) {
        var target = card.offsetLeft - (grid.clientWidth - card.clientWidth) / 2;
        grid.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
      }

      function closestCardIndex() {
        var center = grid.scrollLeft + grid.clientWidth / 2;
        var closest = 0;
        var closestDist = Infinity;
        cards.forEach(function (card, i) {
          var cardCenter = card.offsetLeft + card.clientWidth / 2;
          var dist = Math.abs(cardCenter - center);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        });
        return closest;
      }

      function go(delta) {
        var idx = closestCardIndex() + delta;
        idx = Math.max(0, Math.min(cards.length - 1, idx));
        centerCard(cards[idx], true);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

      var featured = grid.querySelector('.lp-selector__card--featured') || cards[Math.floor(cards.length / 2)];

      function centerFeaturedIfMobile() {
        if (isMobile() && featured) centerCard(featured, false);
      }

      centerFeaturedIfMobile();
      window.addEventListener('load', centerFeaturedIfMobile);

      var lastIsMobile = isMobile();
      window.addEventListener('resize', function () {
        var nowMobile = isMobile();
        if (nowMobile && !lastIsMobile) centerFeaturedIfMobile();
        lastIsMobile = nowMobile;
      });
    }

    function initCountdown(root) {
      var TIMEZONE = 'Australia/Melbourne';
      var CUTOFF_HOUR = 16;
      var days = parseInt(root.dataset.deliveryDays || '2', 10);
      var dateEl = root.querySelector('[data-delivery-countdown-date]');
      var timerEl = root.querySelector('[data-delivery-countdown-timer]');
      var dateShortEl = root.querySelector('[data-delivery-countdown-date-short]');
      var timerShortEl = root.querySelector('[data-delivery-countdown-timer-short]');
      if (!dateEl && !timerEl && !dateShortEl && !timerShortEl) return;

      function nowInTZ() {
        var parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: TIMEZONE,
          hour12: false,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        }).formatToParts(new Date());
        var map = {};
        parts.forEach(function (part) {
          map[part.type] = part.value;
        });
        return new Date(Date.UTC(+map.year, +map.month - 1, +map.day, +map.hour, +map.minute, +map.second));
      }

      function isWeekend(date) {
        var day = date.getUTCDay();
        return day === 0 || day === 6;
      }

      function addBusinessDays(date, count) {
        var result = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
        var added = 0;
        while (added < count) {
          result.setUTCDate(result.getUTCDate() + 1);
          if (!isWeekend(result)) added += 1;
        }
        return result;
      }

      function nextCutoff(now) {
        var todayCutoff = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), CUTOFF_HOUR, 0, 0));
        if (!isWeekend(now) && now.getTime() < todayCutoff.getTime()) {
          return todayCutoff;
        }
        var next = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
        do {
          next.setUTCDate(next.getUTCDate() + 1);
        } while (isWeekend(next));
        return new Date(Date.UTC(next.getUTCFullYear(), next.getUTCMonth(), next.getUTCDate(), CUTOFF_HOUR, 0, 0));
      }

      function formatDate(date) {
        return new Intl.DateTimeFormat('en-AU', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' })
          .format(date)
          .replace(',', ',');
      }

      function formatDateShort(date) {
        return new Intl.DateTimeFormat('en-AU', { day: 'numeric', month: 'short', timeZone: 'UTC' }).format(date);
      }

      function formatDuration(ms) {
        var totalMinutes = Math.max(0, Math.ceil(ms / 60000));
        var hours = Math.floor(totalMinutes / 60);
        var minutes = totalMinutes % 60;
        var hourLabel = hours === 1 ? 'hr' : 'hrs';
        var minLabel = minutes === 1 ? 'min' : 'mins';
        if (hours <= 0) return minutes + ' ' + minLabel;
        return hours + ' ' + hourLabel + ' ' + minutes + ' ' + minLabel;
      }

      function formatDurationShort(ms) {
        var totalMinutes = Math.max(0, Math.ceil(ms / 60000));
        var hours = Math.floor(totalMinutes / 60);
        var minutes = totalMinutes % 60;
        if (hours <= 0) return minutes + 'm';
        return hours + 'h ' + minutes + 'm';
      }

      var cutoff = nextCutoff(nowInTZ());

      function renderDate() {
        var eta = addBusinessDays(nowInTZ(), days);
        if (dateEl) dateEl.textContent = formatDate(eta);
        if (dateShortEl) dateShortEl.textContent = formatDateShort(eta);
      }

      function tick() {
        var now = nowInTZ();
        if (now.getTime() >= cutoff.getTime()) {
          cutoff = nextCutoff(now);
          renderDate();
        }
        var remaining = cutoff.getTime() - now.getTime();
        if (timerEl) timerEl.textContent = formatDuration(remaining);
        if (timerShortEl) timerShortEl.textContent = formatDurationShort(remaining);
      }

      renderDate();
      tick();
      setInterval(tick, 1000);
    }

    function initAll() {
      document.querySelectorAll('.lp-selector').forEach(init);
      document.querySelectorAll('[data-delivery-countdown]').forEach(initCountdown);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__statsCountInit) return;
    window.__statsCountInit = true;

    function formatNumber(value, hasComma, decimals) {
      var fixed = value.toFixed(decimals);
      if (hasComma) {
        var parts = fixed.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        fixed = parts.join('.');
      }
      return fixed;
    }

    function animateStat(el) {
      var raw = el.textContent.trim();
      var match = raw.match(/[\d,]+(\.\d+)?/);
      if (!match) return;

      var numStr = match[0];
      var target = parseFloat(numStr.replace(/,/g, ''));
      if (isNaN(target)) return;

      var prefix = raw.slice(0, match.index);
      var suffix = raw.slice(match.index + numStr.length);
      var hasComma = numStr.indexOf(',') !== -1;
      var decimals = (numStr.split('.')[1] || '').length;
      var duration = 1000;
      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        el.textContent = prefix + formatNumber(target * progress, hasComma, decimals) + suffix;
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = raw;
        }
      }

      requestAnimationFrame(step);
    }

    function initStatsCount() {
      document.querySelectorAll('[data-stats-number]').forEach(function (el) {
        if (el.dataset.animated) return;
        el.dataset.animated = 'true';
        animateStat(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStatsCount);
    } else {
      initStatsCount();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
